import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'

function createNewRelicAgent(configuration) {
    const options = {
        init: {
            distributed_tracing: {
                enabled: true
            },
            privacy: {
                cookies_enabled: true
            },
            ajax: {
                deny_list: ["bam.nr-data.net"]
            },
            page_action: {
                enabled: true
            }
        }, // NREUM.init
        info: {
            beacon: "bam.nr-data.net",
            errorBeacon: "bam.nr-data.net",
            licenseKey: [configuration.newRelicConfiguration.licenseKey],
            applicationID: [configuration.newRelicConfiguration.applicationID],
            sa: 1
        }, // NREUM.info
        loader_config: {
            accountID: [configuration.newRelicConfiguration.accountID],
            trustKey: [configuration.newRelicConfiguration.trustKey],
            agentID: [configuration.newRelicConfiguration.agentID],
            licenseKey: [configuration.newRelicConfiguration.licenseKey],
            applicationID: [configuration.newRelicConfiguration.applicationID]
        } // NREUM.loader_config
    }

    new BrowserAgent(options)
}

export { createNewRelicAgent }
